import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Layout from '../../components/Layout';
import Title from '../../components/Title';
import FormActiveComponent from '../../components/FormActive';
import FormSnackbar from '../../components/FormSnackbar';

import useCases from '../../useCases';
import Button from '../../components/Button';
import Spinner from '../../components/Spinner';

import paths from '../../routes/paths';
import asyncErrorsCode from '../../config/asyncErrorsCode';

import { useMediaQuery } from 'react-responsive';
import { Images } from '../../themes';
import {
  Container,
  ButtonContainer,
  Paragraph,
  SnackbarContainer,
} from './styles';

export default function Form({ lead }) {
  const history = useHistory();
  const {
    register,
    handleSubmit,
    errors,
    watch,
    setValue,
    triggerValidation,
  } = useForm();
  const [fetching, setFetching] = useState(false);
  const [defaultValues, setDefaultValues] = useState(lead);
  const [error, setError] = useState(null);
  const watchEmailField = watch('email');
  const watchCompanyField = watch('company');
  const isMobile = useMediaQuery({ query: '(max-width: 960px)' });

  useEffect(() => {
    setDefaultValues(lead);
  }, [lead]);

  // clean error if email or company changes
  useEffect(() => {
    if (
      error &&
      (error.code === asyncErrorsCode.emailAlreadyRegistered ||
        error.code === asyncErrorsCode.companyAlreadyRegistered)
    ) {
      setError(undefined);
    }
  }, [watchEmailField, watchCompanyField]);

  const onSubmit = async formData => {
    setFetching(true);
    const result = await useCases.saveLeadActivate(formData);
    setFetching(false);

    if (!result.success) {
      setError(result.data[0]);
      return;
    }

    history.push(paths.acceptTerms, { canBack: true });
  };

  return (
    <Layout activeRoute="activate" mapImageOnBackground={!isMobile}>
      <Container>
        <Title>
          Get Started with <highlight>InStation</highlight>
        </Title>
        <FormActiveComponent
          defaultValues={defaultValues}
          register={register}
          errors={errors}
          watch={watch}
          setValue={setValue}
          triggerValidation={triggerValidation}
        />

        <ButtonContainer>
          <Paragraph>You will receive instructions on the next steps in your email</Paragraph>
          {fetching ? (
            <Spinner size={{ width: 210, height: 47 }} />
          ) : (
            <Button
              onClick={handleSubmit(onSubmit)}
              icon={Images.icons.instation}
              alt={'InStation logo'}
              text={'Get Started'}
            />
          )}
        </ButtonContainer>

        {!!error && (
          <SnackbarContainer>
            <FormSnackbar message={error.detail} />
          </SnackbarContainer>
        )}
      </Container>
    </Layout>
  );
}

Form.propTypes = {
  lead: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    company: PropTypes.string,
    phone: PropTypes.string,
  }),
};
